ArchivedCardsView = require 'app/scripts/views/archive/archived-cards-view'
ArchivedListsView = require 'app/scripts/views/archive/archived-lists-view'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
l = require 'app/scripts/lib/localize'

module.exports = class ArchiveView extends View
  viewTitleKey: 'archive'
  className: 'board-menu-content-frame'

  events:
    'click .js-switch-section': 'didClickSwitchSections'
    'input .js-search': 'searchChanged'

  initialize: ->
    @searchText = @slot('')

    @cardsView = @subview(ArchivedCardsView, @model, { @searchText }).render()
    @listsView = @subview(ArchivedListsView, @model, { @searchText }).render()

    @activeSubview = @slot(@cardsView)

  searchChanged: ->
    @searchText.set @$searchInput.val().trim()

  didClickSwitchSections: (e) ->
    other = (actual, opt1, opt2) ->
      if actual == opt1 then opt2 else opt1

    @activeSubview.set other(@activeSubview.get(), @cardsView, @listsView)

    @$searchInput.focus()
    # We have to stop this, or else the
    # button will steal keyboard focus
    Util.stop(e)

  injectSubview: (subview) ->
    @$('.js-archive-content').append subview.el
    subview.didBecomeActive()

  renderOnce: ->
    @$el.html templates.fill('board_archive')

    @$searchInput = @$('.js-search')

    @subscribeChanges @activeSubview,
      in: @injectSubview
      out: (view) -> view.$el.detach()

    @watch 'activeSubview', (newSubview) =>
      key = if newSubview == @cardsView
        'switch to archived lists'
      else
        'switch to archived cards'
      @$('.js-switch-section').text l(key)

    @watch 'activeSubview.isLoading', (isLoading) =>
      @$('.js-loading-spinner').toggleClass 'hide', !isLoading
      @$('.js-archive-content').toggleClass 'hide', isLoading

    return @
